<template>
  <el-dialog fullscreen :visible="isShow" :modal="false" :show-close="false" custom-class="dialog-form">
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i> 外协单表单</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <el-row class="form-top-btns">
      <template v-if="role_name === '超级权限' || role_name === '软件管理'">
        <el-button v-if="!formStatus && formData.id !== '0'" type="primary" size="mini" plain round icon="em-icon-edit" @click="formStatus = !formStatus"> 编辑</el-button>
        <el-button v-if="formStatus && formData.id !== '0'" type="info" size="mini" plain round icon="em-icon-edit" @click="formStatus = !formStatus"> 取消编辑</el-button>
        <el-button v-if="formStatus" type="primary" size="mini" plain round icon="em-icon-save" @click="handerSave"> 提交保存</el-button>
      </template>
      <el-button type="danger" size="mini" plain round icon="el-icon-close" @click="close">关闭</el-button>
    </el-row>
    <div class="form-container">
      <el-form ref="form" :model="formData" size="mini" label-width="80px">
        <div class="form-main">
          <el-row>
            <el-col :span="6">
              <el-form-item label="外协日期" required>
                 <el-date-picker v-if="formStatus" value-format="yyyy-MM-dd HH:mm" type="datetime" size="mini" placeholder="选择日期" clearable v-model="formData.date"></el-date-picker>
                 <span v-else>{{formData.date}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="样本册" required>
                <el-autocomplete v-if="formStatus" style="width: 100%"
                    popper-class="my-autocomplete"
                    v-model="formData.product_name"
                    :fetch-suggestions="querySearchAsync"
                    placeholder="请输入内容"
                    @select="handleSelect"
                    @blur="handblur">
                  <i
                      class="el-icon-edit el-input__icon"
                      slot="suffix"
                      @click="handleIconClick">
                  </i>
                  <template slot-scope="{ item }">
                      <span>{{ item.name }}</span>
                  </template>
                </el-autocomplete>
                <span v-else>{{formData.product_name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="外协商" required>
                <el-autocomplete v-if="formStatus" style="width: 100%"
                    popper-class="my-autocomplete"
                    v-model="formData.company_name"
                    :fetch-suggestions="queryCompanySearchAsync"
                    placeholder="请输入内容"
                    @select="handleCompanySelect"
                    @blur="handCompanyblur">
                  <i
                      class="el-icon-edit el-input__icon"
                      slot="suffix"
                      @click="handleCompanyIconClick">
                  </i>
                  <template slot-scope="{ item }">
                      <span>{{ item.name }}</span>
                  </template>
                </el-autocomplete>
                <span v-else>{{formData.company_name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="外协单号">
                <el-input v-if="formStatus" placeholder="外协单号" v-model="formData.order_no" disabled></el-input>
                <span v-else>{{formData.order_no}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
              <el-col :span="6">
              <el-form-item label="备注">
                <el-input v-if="formStatus" placeholder="备注" v-model="formData.remark"></el-input>
                <span v-else>{{formData.remark}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div style="height: 28px; padding-top: 5px;">
          <div style="border-box; padding:0 5px; width: 70%; height: 100%; float: left;">
            <div class="detail-header">
              <div class="detail-title"><i class="em-icon-th-list"></i> 出库明细</div>
              <el-button v-if="outsource_company_id !== '0'" type="success" size="mini" icon="el-icon-success" round @click="handlerBatchConfirm">批量确认</el-button>
            </div>
          </div>
          <div style="width: 30%; height: 100%; float: right;">
            <div class="detail-header">
              <div class="detail-title"><i class="em-icon-th-list"></i> 样本册附件</div>
            </div>
          </div>
        </div>
        <div class="el-table-container form-details" style="top: 107px;">
          <div style="position: relative; box-size: border-box; padding:0 5px; width: 70%; height: 100%; float: left;">
            <el-table :data="formData.details" size="mini" height="100%" style="width: 100%; border:1px solid #d1d1d1;" border header-row-class-name="list-header-row" :row-class-name="tableRowClassName" @selection-change="selectHandler">
              <el-table-column v-if="outsource_company_id !== '0'" type="selection" width="40" align="center" :selectable="selectableHandler"></el-table-column>
              <el-table-column label="序号" type="index" width="47" align="center"></el-table-column>
              <el-table-column label="部品名称" prop="base_material_name" width="150" align="center"></el-table-column>
              <el-table-column label="出库数量" prop="current_number" width="60" align="center"></el-table-column>
              <el-table-column label="接收数量" width="60" align="center">
                <template v-slot:default="scope">
                  <el-input size="mini" v-if="!scope.row.outsource_instore_id && outsource_company_id !== '0'" @change="receiveChange(scope.row)" placeholder="接收数量" class="txtC" v-model="scope.row.receive_number"></el-input>
                  <span v-else>{{scope.row.receive_number}}</span>
                </template>
              </el-table-column>
              <el-table-column label="库位" prop="position_value" width="150" align="center"></el-table-column>
              <el-table-column label="出库单号" prop="outstore_no" width="150" align="center"></el-table-column>
              <el-table-column label="出库日期" prop="outstore_date" width="150" align="center"></el-table-column>
              <el-table-column label="异常原因" width="200" align="center">
                <template v-slot:default="scope">
                  <el-input size="mini" v-if="scope.row.current_number !== scope.row.receive_number && !scope.row.outsource_instore_id" placeholder="异常原因" v-model="scope.row.exception_result"></el-input>
                  <span v-else>{{scope.row.exception_result}}</span>
                </template>
              </el-table-column>
              <el-table-column label="备注" prop="remark" align="center"></el-table-column>
              <el-table-column v-if="formData.id !== '0' && outsource_company_id !== '0'" label="操作" width="100" align="center">
                <template v-slot:default="scope">
                  <el-button v-if="!scope.row.outsource_instore_id" type="success" size="mini" round icon="el-icon-success" @click.stop.prevent="handlerConfirmDetails(scope.row)">确认</el-button>
                  <el-button v-else type="danger" size="mini" round icon="el-icon-error" @click.stop.prevent="handlerCancelDetails(scope.row)">取消</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="position: relative; width: 30%; height: 100%; float: right;">
            <el-table :data="formData.attaches" size="mini" height="100%" style="width: 100%; border:1px solid #d1d1d1;" border header-row-class-name="list-header-row" row-class-name="list-row">
              <el-table-column label="序号" type="index" width="47" align="center"></el-table-column>
              <el-table-column label="文件名称" prop="file_name" align="center"></el-table-column>
              <el-table-column label="操作" width="50" align="center">
                <template v-slot:default="scope">
                  <el-button type="success" size="mini" icon="el-icon-download" circle @click.stop.prevent="handlerDownload(scope.row.file_url)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="form-footer">
          <span>制单人：{{formData.creater_name}}</span>
          <span>制单日期：{{formData.create_time.substring(0,10)}}</span>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>
<style>
  .el-table .warning-row {
    background: #ffaa96;
  }
</style>
<script>
export default {
  name: 'EzzDialogForm',
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {
      // 当前子组件对话框的显隐
      isShow: false,
      formData: null,
      selectedIds: [],
      formEmptyData: {
        id: '0',
        order_no: '',
        date: '',
        product_id: '',
        product_name: '',
        company_id: '',
        company_name: '',
        remark: '',
        details: [],
        attaches: [],
        creater_name: sessionStorage.getItem('operator'),
        creater_id: sessionStorage.getItem('operator_id'),
        create_time: ''
      },
      productList: [],
      product_check: '',
      companyList: [],
      company_check: '',
      operator_id: sessionStorage.getItem('operator_id'),
      formStatus: false,
      editable: this.$store.state.editable,
      delable: this.$store.state.delable,
      outsource_company_id: sessionStorage.getItem('outsource_company_id'),
      role_name: sessionStorage.getItem('role_name')
    }
  },
  beforeCreate: function () {
    var date = new Date()
    var month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var day = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()
    var hours = date.getHours() <= 9 ? '0' + date.getHours() : date.getHours()
    var mins = date.getMinutes() <= 9 ? '0' + date.getMinutes() : date.getMinutes()
    this.currentDate = date.getFullYear() + '-' + month + '-' + day
    this.currentTime = date.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + mins
  },
  created: function () {
    this.formData = JSON.parse(JSON.stringify(this.formEmptyData))
  },
  mounted: function () {
  },
  methods: {
    // 样本册搜索
    loadProduct: function () {
      let _this = this
      _this.get(_this.$apis.getInstoreProduct, {}, function (res) {
        _this.productList = res.data.dataList
      })
    },
    querySearchAsync: function (queryString, cb) {
      this.product_check = 'false'
      var results = queryString ? this.productList.filter(this.createStateFilter(queryString)) : this.productList

      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        cb(results)
      }, 500 * Math.random())
    },
    createStateFilter: function (queryString) {
      return (product) => {
        return product.name.indexOf(queryString) > -1
      }
    },
    handleSelect: function (item) {
      let _this = this
      _this.product_check = 'true'
      _this.formData.product_name = item.name
      _this.formData.product_id = item.id
      // 获取样本册对应附件
      _this.post(_this.$apis.getProductAttach, { ProductId: _this.formData.product_id }, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          _this.formData.attaches = _json.attach
        }
      })
    },
    handleIconClick: function (ev) {
      console.log(ev)
    },
    handblur: function () {
      if (this.product_check === 'false') {
        this.formData.product_name = ''
      }
    },
    // 外协商搜索
    loadCompany: function () {
      let _this = this
      _this.get(_this.$apis.getOrderCompany, {}, function (res) {
        _this.companyList = res.data.dataList
      })
    },
    queryCompanySearchAsync: function (queryString, cb) {
      this.company_check = 'false'
      var results = queryString ? this.companyList.filter(this.createCompanyStateFilter(queryString)) : this.companyList

      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        cb(results)
      }, 500 * Math.random())
    },
    createCompanyStateFilter: function (queryString) {
      return (company) => {
        return company.name.indexOf(queryString) > -1
      }
    },
    handleCompanySelect: function (item) {
      let _this = this
      _this.company_check = 'true'
      _this.formData.company_name = item.name
      _this.formData.company_id = item.id
    },
    handleCompanyIconClick: function (ev) {
      console.log(ev)
    },
    handCompanyblur: function () {
      if (this.company_check === 'false') {
        this.formData.company_name = ''
      }
    },
    // 加载数据
    loadData: function () {
      let _this = this
      _this.post(_this.$apis.getOutsourceOrderForm, { OrderId: _this.formData.id }, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          if (_json.formData != null) {
            _this.formData = _json.formData
          } else {
            _this.formData = JSON.parse(JSON.stringify(_this.formEmptyData))
            _this.formData.creater_id = _this.operator_id
            _this.formData.create_time = _this.currentDate
            _this.formData.date = _this.currentTime
          }
        }
      })
    },
    close: function () {
      this.$confirm('确定关闭？', '提示', {})
        .then(_ => {
          this.isShow = false
        })
        .catch(_ => {
          return false
        })
    },
    // 行颜色变化（入库数量和送货数量不等）
    tableRowClassName ({ row, rowIndex }) {
      if (row.receive_number !== row.current_number) {
        return 'warning-row'
      } else {
        return 'list-row'
      }
    },
    handlerDownload: function (_fileUrl) {
      window.open(this.$apiroot + _fileUrl)
    },
    addHandler: function () {
      this.formData.id = '0'
      this.loadProduct()
      this.loadCompany()
      this.loadData()
      this.isShow = true
      this.formStatus = true
    },
    viewHandler: function (formId) {
      this.formData.id = formId
      this.loadProduct()
      this.loadCompany()
      this.loadData()
      this.isShow = true
      this.formStatus = false
    },
    receiveChange: function (item) {
      if (item.receive_number === item.current_number) {
        item.exception_result = ''
      }
    },
    // 批量确认
    handlerBatchConfirm: function () {
      let _this = this
      let _ids = _this.selectedIds.join(',')
      if (_ids.length === 0) {
        _this.$message({
          type: 'warning',
          message: '至少选择一条数据'
        })
      } else {
        let selectDetails = _this.formData.details.filter(function (item) {
          return _ids.indexOf(item.id) > -1
        })
        for (var i = 0; i < selectDetails.length; i++) {
          selectDetails[i].operator_id = _this.operator_id
        }
        _this.post(_this.$apis.saveBatchOutsourceOrderDetail, selectDetails, function (res) {
          let _json = res.data
          if (_json.status && _json.status === 'logout') {
            _this.logout()
          } else {
            if (_json.status === 'ok') {
              _this.$message({
                message: '确认成功',
                type: 'success'
              })
              _this.viewHandler(_this.formData.id)
            }
          }
        })
      }
    },
    // 确认事件
    handlerConfirmDetails: function (_row) {
      let _this = this
      if (_row.receive_number !== _row.current_number && _row.exception_result === '') {
        _this.$message({
          message: '请填写异常原因',
          type: 'error'
        })
      } else {
        _row.operator_id = _this.operator_id
        _row.outsource_order_id = _this.formData.id
        _this.post(_this.$apis.saveOutsourceOrderDetail, _row, function (res) {
          let _json = res.data
          if (_json.status && _json.status === 'logout') {
            _this.logout()
          } else {
            if (_json.status === 'ok') {
              _this.$message({
                message: '确认成功',
                type: 'success'
              })
              _row.outsource_instore_id = _json.outsource_instore_id
            }
          }
        })
      }
    },
    // 取消确认事件
    handlerCancelDetails: function (_row) {
      let _this = this
      _this.post(_this.$apis.delOutsourceOrderDetail, _row, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          if (_json.status === 'ok') {
            _this.$message({
              message: '取消成功',
              type: 'success'
            })
            _row.outsource_instore_id = ''
          }
        }
      })
    },
    // 表单验证，_mainData是主表数据，_detailData从表数据，如果只验证从表数据，_mainData要设置为null
    validationHandler: function (_mainData) {
      let _this = this
      if (_mainData !== null) {
        if (_mainData.date === '') {
          _this.$message({
            type: 'error',
            message: '外协日期不能为空'
          })
          return false
        }
        if (_mainData.product_name === '') {
          _this.$message({
            type: 'error',
            message: '样本册不能为空'
          })
          return false
        }

        if (_mainData.company_name === '') {
          _this.$message({
            type: 'error',
            message: '外协商不能为空'
          })
          return false
        }
      }
      return true
    },
    // 新增时主从表同时保存
    handerSave: function () {
      let _this = this
      if (_this.validationHandler(_this.formData)) {
        _this.formData.operator_id = _this.operator_id
        _this.post(_this.$apis.saveOutsourceOrderForm, _this.formData, function (res) {
          let _json = res.data
          if (_json.status && _json.status === 'logout') {
            _this.logout()
          } else {
            if (_json.status === 'ok') {
              _this.$message({
                message: '保存成功',
                type: 'success'
              })
              _this.formData.id = _json.id
              _this.formData.order_no = _json.order_no
              _this.formStatus = false
              _this.parent.loadData()
            }
          }
        })
      }
    },
    // 多选事件
    selectHandler: function (selection) {
      this.selectedIds = []
      for (let i = 0; i < selection.length; ++i) {
        this.selectedIds.push(selection[i].id)
      }
    },
    // 通过该方法，控制列表 checkbox 列是否允许勾选
    selectableHandler: function (_row, _index) {
      if ((_row.receive_number !== _row.current_number && _row.exception_result === '') || _row.outsource_instore_id) {
        return false
      } else {
        return true
      }
    }
  },
  components: {

  }
}
</script>
